import { bool, node } from "prop-types";
import { forwardRef, useRef, useState } from "react";

import styled from "styled-components";

import dynOpactity from "Utilities/interpolations/dynOpactity";

/**
 *
 * @param {object} param0
 * @param {boolean} param0.active - is the shine active? Still displays children when false.
 * @returns
 */
const ShineWrapper = forwardRef(
  ({ isActive, children, ...rest }, passedInRef) => {
    const localRef = useRef();
    const ref = passedInRef || localRef;

    const [shineCenterX, setShineCenterX] = useState("50%");

    const frameRef = useRef(null);

    const handleMouseMove = ({ clientX }) => {
      if (frameRef.current) return; // skip until next frame
      frameRef.current = requestAnimationFrame(() => {
        setShineCenterX(`${((clientX - 8) / 324) * 100}%`);
        frameRef.current = null;
      });
    };

    return (
      <Wrapper
        style={{ "--shineCenterX": shineCenterX }}
        onMouseMove={handleMouseMove}
        ref={ref}
        $isActive={isActive}
        $opacity={isActive ? 1 : 0}
        data-cy="ShineWrapper"
        {...rest}
      >
        {children}
      </Wrapper>
    );
  }
);

const transition = ({ $isActive }) => {
  if ($isActive)
    return `
      &:after {
        transition: opacity 2s;
      }
      &:hover:after {
        transition: opacity 0.4s;
      }
    `;
  return `
    &:after {
      transition: opacity 0.2s;
    }
  `;
};

const Wrapper = styled.div`
  position: relative;
  &:before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    content: "";
    display: block;
    inset: 0;
    border-radius: 28px;
    overflow: hidden;
    background: radial-gradient(
      280px circle at var(--shineCenterX) 0%,
      rgba(255, 255, 255, 0.08),
      rgba(255, 255, 255, 0)
    );
    ${transition}
    ${dynOpactity}
  }
`;

ShineWrapper.propTypes = { children: node, isActive: bool };

export default ShineWrapper;
